import {useState, useContext} from "react"
import {UserContext, UpdateUserContext} from "../../App"
import {shuffleArray, disblur, color_note, message_to_users, currentPeriod, IsInPeriod} from "../Fonctions"
import {Modal} from "../question/Modal"


function addNote(auth, updateUsercontext) {
  
  fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify({...auth, action:'replayable'})
    })
    .then(response => response.json())
    .then(data => {
      updateUsercontext()
      //update('user')
    })
    .catch(err => console.log(err))
}

export function Devoirs_eleve ({auth, setAuth}) {
  
  const {currentUser} = useContext(UserContext)
  const user = currentUser
  const updateUsercontext = useContext(UpdateUserContext)
  if(!user.devoir_a_faire) {user.devoir_a_faire=[]}

  const [show_activite, setShow_activite] = useState(false)
  const [tab, setTab] = useState([])
  const [data_serie, setData_serie] = useState({})
  //const [msg, setMsg] = useState('')

  const handleClick = (e) => {

    const selection = e.target.title.split('__')
    let activite = ''
    let niveau = ''
    let etoile = ''
    let nb_question = ''
    let donne_par = ''
    let donne_le = ''
    let title = ''
    let replayable = ''
    let listeChoix = ''
    let nbEssaisMin = ''
    let noteRef = 0.1

    if(e.target.attributes.name.nodeValue === 'replay') {
      niveau = user.activites[e.target.title].niveau
      etoile = user.activites[e.target.title].etoile
      nb_question = user.activites[e.target.title].nb_question
      donne_par = user.activites[e.target.title].donne_par
      donne_le = user.activites[e.target.title].donne_le
      title = user.activites[e.target.title].title
      activite = user.activites[e.target.title].activite
      listeChoix = user.activites[e.target.title].listeChoix
      noteRef = user.activites[e.target.title].note
      nbEssaisMin = user.mes_stats.filter(st => st.activite === e.target.title).length ? user.mes_stats.filter(st => st.activite === e.target.title)[0].nbEssaisMin : 1
    } else {
      user.devoir_a_faire.forEach(elt => {
        if(elt.activite === e.target.title) {
          //console.log(elt)
          niveau = elt.niveau
          etoile = elt.etoile
          nb_question = elt.nb_question      
          donne_par = elt.donne_par    
          donne_le = elt.donne_le      
          title = elt.title
          activite = elt.activite
          listeChoix = elt.listeChoix
          nbEssaisMin = elt.nbEssaisMin
          //replayable = elt.listeChoix.length === 0
          replayable = elt.replayable
          if(replayable === '0') { addNote({...auth, activite, nb_question, etoile, niveau, donne_par, donne_le, title, note:'1', replayable, nbEssaisMin}, updateUsercontext) }
          //elt.listeChoix ? setMsg('ok') : setMsg('')
        }
      })
    }

    setShow_activite(true)
    //setTimeout(e => {setMsg('')}, 5000)
    setData_serie({activite:e.target.title, nb_question, etoile, niveau, donne_par, listeChoix, replayable})
    setAuth({...auth, activite:e.target.title, nb_question, etoile, niveau, donne_par, donne_le, title, replayable, listeChoix, noteRef, nbEssaisMin})

    /*fetch("https://maths-au-quotidien.fr/react-automaths/api-questions.php", {
      method: 'POST',
      body: JSON.stringify({...auth, action:'rech_question',activite:e.target.title, title, notion:selection, nb_question, etoile, niveau, donne_par, listeChoix:user.devoir_a_faire[e.target.id]?.listeChoix})
    })
    .then(response => response.json())
    .then(data => {
      //console.log('data', data)

      let final_tab = []
      let num = Object.keys(data)
      shuffleArray(num)

      num.forEach(e => final_tab.push(disblur(data[e])))
      setTab(final_tab)
    })
    .catch(err => console.log(err))*/
  }

  //console.log(user.devoir_a_faire)
  //console.log(user)
  const postit = () => {
    return <div className="post-it">
              <div className="note_serie yellow">
                <i className="pin"></i>
                <h1>Travail à faire</h1>
                {user.devoir_a_faire.map((e, k0) => <span key={k0} title={e.activite.replaceAll('__', '\u000d')} >
                  {e.date_limit !=='0000-00-00' ? <b>Pour le {e.date_limit.slice(-2)}/{e.date_limit.slice(-5, -3)} :<br/></b> : ''}
                  {e.facultatif==="1" && '(Facultatif) '}<b>{e.title || e.activite.replaceAll('__', ', ').slice(0,40)+'...'}</b><br/>
                  {e.consigne && <div className="consigne">{e.consigne}<br/></div>}
                  {e.nbEssaisMin*1 > 1 && <div className="NbEssaisMin">({e.nbEssaisMin} essais minimum)</div>}
                  {e.replayable === '0' ? <div style={{color:'grey'}}>(Un seul essai)</div> :''}
                  {e.listeChoix.includes('_') ? e.listeChoix.split('_').length : e.nb_question}Q {'⭐'.repeat(e.etoile)} → <input name="devoir_a_faire" type="button" id={k0} title={e.activite} value="Faire ce devoir" onClick={handleClick} />
                  {k0 === user.devoir_a_faire.length -1 || <hr style={{width:"70%"}} /> }
                </span>)}
              </div>
            </div>
  }

  // =========== Période =========== 
  let tab_activ = Object.keys(user.activites)
  /*const tab_period = [
      '2024-09-01_2024-11-15',
      '2024-11-16_2024-03-10',
      '2024-03-11_2024-06-30',
    ]

  let period = currentPeriod(tab_period) 
  tab_activ = Object.keys(user.activites).filter(e => IsInPeriod(user.activites[e].donne_le, period))*/
  //tab_activ = tab_activ.filter(activ => IsInPeriod(activ.donne_le, period))
  // ===========================

  const affiche_etiquette = () =>
    tab_activ?.map((activ, k) => 
        <div key={k} className="etiquette" title={activ.replaceAll('__', '\u000d')} >
          <div className="info_mess">{user.activites[activ].donne_le}</div>
          <span className={color_note(user.activites[activ].note)}><b>{user.activites[activ].note}%</b></span> {'⭐'.repeat(user.activites[activ].etoile)} <div className="nb_question_serie">{user.activites[activ].nb_question}Q</div>
          {user.activites[activ].replayable === '0' ? <span style={{color:'grey'}}> Un seul essai</span> :''}
          <div name="stat_groupe" className="stat_groupe" onClick={(e)=>e.target.classList.toggle('active')}>
            <span title="Note minimale de la classe">Min: {user.stat_classe[activ].min}%</span>
            <span title="Moyenne de la classe">Moy: {user.stat_classe[activ].moy}%</span>
            <span title="Note maximale de la classe">Max: {user.stat_classe[activ].max}%</span>
          </div>
          {user.activites[activ].title || (activ.replaceAll('__', ', ').length > 30 ? activ.replaceAll('__', ', ').slice(0,30)+'...' : activ.replaceAll('__', ', '))}
          {user.activites[activ].replayable === '1' &&
          <div name='replay' title={activ} className="replay" onClick={handleClick} ></div>}
        </div>)
  
  
  /*
      <div className='modal active'>
        <div className="suppr_serie" onClick={()=>{setShow_activite(false)}}></div>
          <AAA001 auth={auth} data_serie={data_serie} tab={tab} setTab={setTab} setShow_activite={setShow_activite} color_note={color_note} />
      </div>
   */
  
  //console.log('data_serie', data_serie)
  //console.log('user_activite', Object.keys(user.activites).map(e=>user.activites[e].donne_le))
  //console.log(auth)
  //console.log(user)
  return (
    <>
    {
      message_to_users(user)
    }

    {show_activite ? 
      <Modal auth={{...auth, profil:user.profil, action:'rech_question', listeChoix:data_serie.listeChoix, notion:data_serie.activite.split('__'), activite:data_serie.activite, niveau:data_serie.niveau, etoile:data_serie.etoile, nb_question:data_serie.nb_question, diff_etoile:user.diff_etoile}} setShow_activite={setShow_activite} />
      : <div className="content max">
    	<h1>Mes résultats Automaths</h1>
      {user.devoir_a_faire[0] && postit()}
      
    	{user.activites ? affiche_etiquette() :
                        <>
                        Retrouver, ici, vos résultats Automaths.<br/><br/>
                        <div className="alert info ">
                            <br/>Vous n'avez pas de résultat Automaths pour le moment.<br/><br/>
                        </div>
                        </>
      }
      <br/>
      {user.activites[user.suggest?.activite] && 
        <>
          <br/>
          <br/>
          Automaths vous suggère de {user.activites[user.suggest.activite].replayable === '1' ?'refaire' : 'retravailler'} le devoir suivant : <br/>
          <div className="etiquette" >
              <span className={color_note(user.activites[user.suggest.activite].note)}><b>{user.activites[user.suggest.activite].note}%</b></span> {'⭐'.repeat(user.suggest.etoile)} <div className="nb_question_serie">{user.suggest.nb_question}Q</div><br/>
              {user.suggest.title || (user.suggest.activite.length > 70 ? user.suggest.activite.replaceAll('__', ', ').slice(0, 70)+'...' : user.suggest.activite.replaceAll('__', ', '))}
             {user.activites[user.suggest.activite].replayable === '1' &&
                           <div name='replay' className="replay" title={user.suggest.activite} onClick={handleClick}></div>}
          </div>
        </>
      }
    </div>
  }
    </>
  );
}